<script lang="ts">
	import { Alert, Text, Button } from '@Shelly/shelly-design-system/index';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { NON_PREMIUM_WIDGETS_LIMIT, PREMIUM_WIDGETS_LIMIT } from 'src/constants';
	import { capFirstChar } from 'src/helpers/utilities';
	import { user_data, user_settings } from 'src/stores/account/user';
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';

	const isPremium = $user_data.premium || $user_settings.been_premium;
	const DASHBOARD_WIDGETS_LIMIT = isPremium ? PREMIUM_WIDGETS_LIMIT : NON_PREMIUM_WIDGETS_LIMIT;

	const modalWidgetLimitReachedTranslation = isPremium
		? 'text_premium_widgets_limit_reached'
		: 'text_basic_widgets_limit_reached';
	const imageUrlWidgetLimitReached = isPremium
		? './images/premium-user-limit-widgets-reached.svg'
		: './images/limit-reached-basic-plan-image.svg';

	const modalWidgetReachedDefault = isPremium
		? `Premium Plan users are limited to ${PREMIUM_WIDGETS_LIMIT} widgets per dashboard. Remove some of your widgets to add a new one.`
		: `Basic Plan users are limited to ${NON_PREMIUM_WIDGETS_LIMIT} widgets per dashboard. Remove some of your widgets to add a new one, or upgrade to Premium to set up to ${PREMIUM_WIDGETS_LIMIT} widgets per dashboard.`;
</script>

<Alert
	type={'danger'}
	heading={$format('reached_maximum_number_of_widgets', {
		default: 'You have reached the maximum number of widgets',
	})}
	isHeadingBold
	class="mb-s"
/>
<div class="d-flex justify-content-center mt-l mb-m">
	<img src={imageUrlWidgetLimitReached} alt="home-screen-mobile-device" />
</div>

<Text class="text-center mb-s" element="h1">
	{$format('text_title_widgets_limit_reached', {
		values: { limit: DASHBOARD_WIDGETS_LIMIT },
		default: `You have reached your limit of ${DASHBOARD_WIDGETS_LIMIT} widgets!`,
	})}
</Text>
<Text class="text-center text-color-muted" styleType="body-extra-small">
	{$format(modalWidgetLimitReachedTranslation, {
		values: {
			limit: DASHBOARD_WIDGETS_LIMIT,
			premiumLimit: PREMIUM_WIDGETS_LIMIT,
		},
		default: modalWidgetReachedDefault,
	})}
</Text>
{#if !isPremium}
	<div class="d-flex justify-content-center">
		<Button
			class="mt-m mb-m text-capitalize"
			variant="premium"
			size="l"
			width="auto"
			on:click={() => {
				setSidePanelState({ open: false });
				push('/settings/premium');
			}}
		>
			{capFirstChar($format('button_get_premium', { default: 'get premium' }))}
		</Button>
	</div>
	<Text styleType="body" class="text-center link-styles" on:click>
		{capFirstChar(
			$format('button_maybe_later', {
				default: 'maybe later',
			}),
		)}
	</Text>
{/if}
